export default __webpack_public_path__ + "static/media/bg-12.d8f57f92.jpg";